// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__1_wX0","Loader":"Loader_Loader__ANdA0","loader1":"Loader_loader1__29svq"};